/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */
import { isNativeAudio } from './nativeAudio'

// Callbacks registered by the component
const _handlers = {
  onPlay:    null,
  onPause:   null,
  onNext:    null,
  onPrev:    null,
  onSeek:    null,
  onForward: null,
  onRewind:  null,
  onStop:    null,
}

// Expose bridge object that native calls back into
if (typeof window !== 'undefined') {
  window.__mediabridge = {
    onPlay:    () => _handlers.onPlay?.(),
    onPause:   () => _handlers.onPause?.(),
    onNext:    () => _handlers.onNext?.(),
    onPrev:    () => _handlers.onPrev?.(),
    onSeek:    (t) => _handlers.onSeek?.(t),
    onForward: () => _handlers.onForward?.(),
    onRewind:  () => _handlers.onRewind?.(),
    onStop:    () => _handlers.onStop?.(),
  }
}

export function setupMediaControls({ title, artist, cover, handlers }) {
  // Register handlers
  Object.assign(_handlers, handlers)
  if (isNativeAudio) return

  // Web — use Media Session API
  if (!('mediaSession' in navigator)) return
  navigator.mediaSession.metadata = new MediaMetadata({
    title:   title  || '',
    artist:  artist || '',
    artwork: cover  ? [{ src: cover, sizes: '96x96', type: 'image/jpeg' }] : []
  })
  navigator.mediaSession.setActionHandler('play',          () => _handlers.onPlay?.())
  navigator.mediaSession.setActionHandler('pause',         () => _handlers.onPause?.())
  navigator.mediaSession.setActionHandler('stop',          () => _handlers.onStop?.())
  navigator.mediaSession.setActionHandler('nexttrack',     () => _handlers.onNext?.())
  navigator.mediaSession.setActionHandler('previoustrack', () => _handlers.onPrev?.())
  navigator.mediaSession.setActionHandler('seekto',        (d) => _handlers.onSeek?.(d.seekTime))
  navigator.mediaSession.setActionHandler('seekforward',   (d) => _handlers.onForward?.())
  navigator.mediaSession.setActionHandler('seekbackward',  (d) => _handlers.onRewind?.())
}

export function updatePlaybackState({ isPlaying, position, duration, speed = 1 }) {
  if (isNativeAudio) return
  if (!('mediaSession' in navigator)) return
  const dur = duration || 0
  const pos = position || 0
  if (!isFinite(dur) || dur <= 0) return
  if (!isFinite(pos)) return
  try {
    navigator.mediaSession.setPositionState({
      duration:     dur,
      playbackRate: speed || 1,
      position:     Math.min(Math.max(pos, 0), dur),
    })
  } catch (e) {}
}

export function destroyMediaControls() {
  if (isNativeAudio) { Object.keys(_handlers).forEach(k => _handlers[k] = null); return }
  if (!('mediaSession' in navigator)) return
  const actions = ['play','pause','stop','nexttrack','previoustrack','seekto','seekforward','seekbackward']
  actions.forEach(a => {
    try { navigator.mediaSession.setActionHandler(a, null) } catch (e) {}
  })
  Object.keys(_handlers).forEach(k => _handlers[k] = null)
}
